export default __webpack_public_path__ + "static/media/rohit-bisht.b98cbded.jpg";